import "./DermatologyPracticeCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Challenges from "./sections/Challenges";
import DermatologyGoal from "./sections/DermatologyGoal";
import DermatologyHero from "./sections/DermatologyHero";
import Roadmap from "./sections/Roadmap";
import Impact from "./sections/Impact";
import VerifiedResults from "./sections/VerifiedResults";
import LocalStrategy from "./sections/LocalStrategy";
import Footer from "@/reusable_sections/Footer";
export default function DermatologyPracticeCaseStudyPage() {
  return <div>
      <Header />
      <Consultation />
      <Challenges />
      <DermatologyGoal />
      <DermatologyHero />
      <Roadmap />
      <Impact />
      <VerifiedResults />
      <LocalStrategy />
      <Footer />
    </div>;
}